"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LoadImage = function () {
  function LoadImage() {
    _classCallCheck(this, LoadImage);
  }

  _createClass(LoadImage, null, [{
    key: "setImage",
    value: function setImage(src) {
      var img = new Image();
      return new Promise(function (resolve, reject) {
        img.onload = function () {
          return resolve(img);
        };
        img.onerror = function (error) {
          return reject(error);
        };
        img.src = src;
      });
    }
  }, {
    key: "readFile",
    value: function readFile(file) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function (e) {
          return resolve(e.target.result);
        };
        reader.onerror = function (error) {
          return reject(console.log(error));
        };
        reader.readAsDataURL(file);
      });
    }
  }]);

  return LoadImage;
}();

exports.default = LoadImage;
var setImage = LoadImage.setImage,
    readFile = LoadImage.readFile;
exports.setImage = setImage;
exports.readFile = readFile;


//////////////////
// WEBPACK FOOTER
// ./node_modules/exif-rotate-js/lib/load-image.js
// module id = 918
// module chunks = 0